export enum SupportedLocale {
  EN_US = 'en-US',
  ZH_CN = 'zh-CN',
  JA_JP = 'ja-JP',
  PT_PT = 'pt-PT',
}
